export const features = [
  {
    id: 'emar',
    riveState: 'EMAR',
    title: 'eMAR',
    subtitle: 'Streamline Medication Administration Process',
    description:
      'Ogiso enhances medication management with a user-friendly eMAR system designed for accuracy and compliance. Record and track medication administration seamlessly, reduce errors, and ensure adherence to protocols.',
  },
  {
    id: 'task',
    riveState: 'TASK',
    title: 'Task Management',
    subtitle: 'Stay Organized with Our Task Manager',
    description:
      'Efficiently track Activities of Daily Living (ADLs) and other tasks with our intuitive task manager. Stay organized and ensure timely completion of essential tasks.',
  },
  {
    id: 'notes',
    riveState: 'NOTES',
    title: 'Progress Notes',
    subtitle: 'Tailored Notes & Outcomes for Effective Care',
    description:
      'Customize your progress notes to fit your specific needs. Our solution ensures clear and effective communication, supporting comprehensive and personalized patient care.',
  },
  {
    id: 'reporting',
    riveState: 'REPORTING',
    title: 'Reporting',
    subtitle: 'Comprehensive Reporting at Your Fingertips',
    description:
      'Generate detailed and insightful reports for all saved records. Our reporting tools provide a comprehensive overview, helping you make informed decisions and maintain accurate records.',
  },
  {
    id: 'skai',
    riveState: 'SKAI',
    title: 'SkAi',
    subtitle: 'AI assistant for your operations',
    description:
      'Create and manage custom forms to track essential business information and maintain compliance. Tailor forms to your specific needs for efficient data collection.',
  },
  {
    id: 'doc',
    riveState: 'DOC',
    title: 'Document Management',
    subtitle: 'Staff & Client Documents in One Place',
    description:
      'Efficiently manage all staff and client documents. Stay on top of document validity with expiration notifications, ensuring all necessary documentation is up-to-date.',
  },
  {
    id: 'staff',
    riveState: 'STAFF',
    title: 'Staff Management',
    subtitle: 'Optimize Team Management',
    description:
      'Oversee your team with ease. Add or deactivate staff, manage documents, assign roles, and generate reports to optimize team management and performance.',
  },
  {
    id: 'billing',
    riveState: 'SCHEDULE',
    title: 'Billing & Invoicing',
    subtitle: 'Get paid faster with confidence',
    description:
      'Bill over 5,000+ payers nationwide using a streamlined and reliable billing workflow built for providers. Ogiso automates submissions, reduces errors, and helps minimize claim rejections so you spend less time fixing issues and more time delivering care.',
  },
];
